/* Creator landing page: no third-party libraries or checkout interception. */
(() => {
  if (window.bandiCreatorInstalled) return;
  window.bandiCreatorInstalled = true;
  const key = "bandi_creator_attribution";
  let cartWritten = false;
  const consent = () =>
    window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true &&
    window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const current = () => {
    const params = new URLSearchParams(location.search);
    const record = {
      source: "baeleeena",
      campaign: "creator-series",
      landing_page: "/baeleena",
      utm_source: "baeleeena",
      utm_medium: "creator",
      utm_campaign: "baeleeena",
    };
    [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "ref",
    ].forEach((name) => {
      if (params.get(name)) record[name] = params.get(name).slice(0, 250);
    });
    if (params.get("utm_source")) record.source = record.utm_source;
    return record;
  };
  const attribution = () => {
    if (consent()) {
      try {
        const old = JSON.parse(localStorage.getItem(key));
        if (old && typeof old === "object" && typeof old.source === "string")
          return old;
        const legacy = localStorage.getItem("bandi_referral_source");
        if (legacy) return { ...current(), source: legacy, utm_source: legacy };
      } catch (_) {
        /* Storage may be unavailable in private browsing. */
      }
    }
    return current();
  };
  const activate = () => {
    const page = document.querySelector("[data-b-page]");
    if (!page || !consent() || window.Shopify?.designMode) return;
    const record = attribution();
    try {
      if (!localStorage.getItem(key))
        localStorage.setItem(key, JSON.stringify(record));
      if (!localStorage.getItem("bandi_referral_source"))
        localStorage.setItem("bandi_referral_source", record.source);
    } catch (_) {
      /* Link attribution still works without persistent storage. */
    }
    if (
      page.dataset.cartAttribution !== "true" ||
      cartWritten ||
      record.source !== "baeleeena"
    )
      return;
    cartWritten = true;
    const root = window.Shopify?.routes?.root || "/";
    fetch(root + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((r) => {
        if (!r.ok) throw new Error("Cart unavailable");
        return r.json();
      })
      .then((cart) => {
        if (cart.attributes?.Creator) return;
        return fetch(root + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ attributes: { Creator: "Baeleeena" } }),
        });
      })
      .catch(() => {
        /* Attribution never blocks navigation or checkout. */
      });
  };
  document.addEventListener("click", async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const copy = target?.closest(".baeleeena-page [data-b-copy]");
    if (copy) {
      const status = copy.closest(".b-perk").querySelector('[role="status"]');
      try {
        await navigator.clipboard.writeText(copy.dataset.bCopy);
        status.textContent = "Code copied.";
      } catch (_) {
        status.textContent = "Your code: " + copy.dataset.bCopy;
      }
    }
    const anchor = target?.closest(".baeleeena-page a[data-b-referral]");
    if (!anchor || anchor.getAttribute("href")?.startsWith("#")) return;
    try {
      const destination = new URL(anchor.href, location.href);
      if (
        destination.origin !== location.origin ||
        !["http:", "https:"].includes(destination.protocol)
      )
        return;
      const record = attribution();
      [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term",
        "ref",
      ].forEach((name) => {
        if (
          typeof record[name] === "string" &&
          !destination.searchParams.has(name)
        )
          destination.searchParams.set(name, record[name]);
      });
      anchor.href = destination.href;
    } catch (_) {
      /* Leave malformed merchant links unchanged. */
    }
  });
  document.addEventListener("visitorConsentCollected", activate);
  document.addEventListener("shopify:section:load", activate);
  const start = () => {
    activate();
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        (error) => {
          if (!error) activate();
        },
      );
    }
  };
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
